import React from 'react';
import './TableSkeleton.css';

/**
 * A themed table loading placeholder: a small "loading" status pill plus a
 * shimmering table card (teal header row + animated body rows) so users get an
 * immediate indication that data is on its way.
 *
 * @param {number} rows - number of skeleton body rows (default 8)
 * @param {number} columns - number of skeleton columns (default 7)
 * @param {string} message - status text shown above the table
 */
const TableSkeleton = ({ rows = 8, columns = 7, message = 'Loading data…' }) => {
    const cols = Array.from({ length: Math.max(1, columns) });
    const bodyRows = Array.from({ length: Math.max(1, rows) });

    return (
        <div className="table-skeleton" role="status" aria-live="polite" aria-busy="true">
            <div className="table-skeleton__status">
                <span className="table-skeleton__spinner" aria-hidden="true">
                    <span></span><span></span><span></span>
                </span>
                <span className="table-skeleton__message">{message}</span>
            </div>

            <div className="table-skeleton__card">
                <div className="table-skeleton__head">
                    {cols.map((_, c) => (
                        <div key={c} className="table-skeleton__cell">
                            <span className="sk-bar sk-bar--head" />
                        </div>
                    ))}
                </div>

                {bodyRows.map((_, r) => (
                    <div key={r} className="table-skeleton__row">
                        {cols.map((_, c) => (
                            <div key={c} className="table-skeleton__cell">
                                <span
                                    className="sk-bar"
                                    style={{ width: `${45 + ((r + c) % 4) * 14}%` }}
                                />
                            </div>
                        ))}
                    </div>
                ))}
            </div>

            <span className="visually-hidden">{message}</span>
        </div>
    );
};

export default TableSkeleton;
